var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58173 12.4183 0 8 0C3.58173 0 0 3.58173 0 8C0 12.4183 3.58173 16 8 16ZM6.28571 10.7143C5.89122 10.7143 5.57143 11.0341 5.57143 11.4286C5.57143 11.8231 5.89122 12.1429 6.28571 12.1429H9.71429C10.1088 12.1429 10.4286 11.8231 10.4286 11.4286C10.4286 11.0341 10.1088 10.7143 9.71429 10.7143H8.71429V7.42857C8.71429 7.03408 8.39449 6.71429 8 6.71429H6.85714C6.46265 6.71429 6.14286 7.03408 6.14286 7.42857C6.14286 7.82306 6.46265 8.14286 6.85714 8.14286H7.28571V10.7143H6.28571ZM9.14286 4.57143C9.14286 5.20261 8.63118 5.71429 8 5.71429C7.36882 5.71429 6.85714 5.20261 6.85714 4.57143C6.85714 3.94025 7.36882 3.42857 8 3.42857C8.63118 3.42857 9.14286 3.94025 9.14286 4.57143Z",
    fill: "#EB3366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.d47848c001a0bc2bed65e705b97e59ce.svg";
export { ForwardRef as ReactComponent };